import MenuTemplate from './MenuTemplate';

export default MenuTemplate;
